import dateMappings from './dateParts';

const normalize = (arr) => arr.reduce(
  (acc, curr) => ({
    values: { ...acc.values, [curr.id]: curr },
    ids: [...acc.ids, curr.id],
  }),
  { values: {}, ids: [] },
);

export const normalizeFloweringArch = (arr) => arr.reduce((acc, curr) => {
  const {
    bee_id: beeId,
    bee_datepart: date,
    interactible_plants: amountOfInteractiblePlants,
  } = curr;

  if (acc.minMonth === null && acc.maxMonth === null) {
    acc.minMonth = date;
    acc.maxMonth = date;
  } else {
    if (dateMappings[date].index < dateMappings[acc.minMonth].index) {
      acc.minMonth = date;
    }
    if (dateMappings[date].index > dateMappings[acc.maxMonth].index) {
      acc.maxMonth = date;
    }
  }

  if (acc.values[beeId]) {
    acc.values[beeId][date] = amountOfInteractiblePlants;
  } else {
    acc.values[beeId] = {};
    acc.values[beeId][date] = amountOfInteractiblePlants;
  }

  return acc;
}, { values: {}, minMonth: null, maxMonth: null });

export const normalizeAdvice = (arr) => {
  const normalized = {};
  arr.forEach(({ plant_id: plantId, relative_impact: relativeImpact }) => {
    normalized[plantId] = Number(relativeImpact);
  });

  return normalized;
};


// export const normalizeInteractiblePlantsByBeeId = (arr) => arr
//   .reduce((acc, curr) => acc[curr.beeId] = curr.interactiblePlants, {});

export const normalizeInteractiblePlantsByBeeId = (arr) => arr
  .reduce((acc, curr) => {
    acc[curr.beeId] = curr.interactiblePlants;

    return acc;
  }, {});

export default normalize;
